// extracted by mini-css-extract-plugin
export default {"root":"MultipleModalAdditionalContent_root__+2JE+","placeHolderShimmer":"MultipleModalAdditionalContent_placeHolderShimmer__BiS9f"};